// src/components/DraggableItem.js
import React from "react";
import { useDrag } from "react-dnd";

const DraggableItem = ({ item, children }) => {
  const [{ isDragging }, dragRef] = useDrag({
    type: "TASK",
    item: { ...item },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={dragRef}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "grabbing",
      }}
    >
      {children}
    </div>
  );
};

export default DraggableItem;
